import { PermissionEnum, apiAbortController } from '@ui/src';
import api from '../../api/api';

export interface PermissionReponse {
  permissions: PermissionEnum[];
}

export const dashboardDictionariesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDashboardPermissions: build.query<{ data: PermissionReponse }, void>({
      query: () => ({
        url: '/v1/employees/whoami',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getDashboardWhitelabel: build.query<
      {
        data: {
          data: {
            value: Record<string, string>;
          };
        };
      },
      void
    >({
      query: () => ({
        url: '/v1/settings/whitelabel',
      }),
    }),
  }),
});

export const {
  useLazyGetDashboardPermissionsQuery,
  useLazyGetDashboardWhitelabelQuery,
} = dashboardDictionariesApi;

export const {
  endpoints: { getDashboardPermissions },
} = dashboardDictionariesApi;
